module.exports = __webpack_public_path__ + "media/images/icons/outlined/team-865f048c82bb798cb35694bf1617e0d2.svg";